module.exports = __webpack_public_path__ + "static/img/cq_lishi.40d91e94.png";